export const toLocalDateString = (date: Date = new Date()): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const calendarMonthRange = (from: Date = new Date()): { von: string; bis: string } => {
  const first = new Date(from.getFullYear(), from.getMonth(), 1);
  const last = new Date(from.getFullYear(), from.getMonth() + 1, 0);
  return { von: toLocalDateString(first), bis: toLocalDateString(last) };
};

export const previousCalendarMonthRange = (from: Date = new Date()): { von: string; bis: string } => {
  return calendarMonthRange(new Date(from.getFullYear(), from.getMonth() - 1, 1));
};

export const parseUtcDateTime = (value: string | Date): Date => {
  if (value instanceof Date) {
    return value;
  }
  const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(value);
  const normalized = value.includes('T') ? value : `${value}T00:00:00`;
  return new Date(hasTimezone ? normalized : `${normalized}Z`);
};

export const toLocalDateTimeInputValue = (value?: string | Date | null): string => {
  if (!value) {
    return '';
  }
  const date = parseUtcDateTime(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const localDateTimeInputValueToUtcIso = (value?: string): string | undefined => {
  if (!value) {
    return undefined;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return undefined;
  }
  return date.toISOString();
};
